import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VerifyAuthCodeQueryVariables = Types.Exact<{
  input: Types.VerifyAuthCodeInput;
}>;


export type VerifyAuthCodeQuery = { __typename?: 'Query', verifyAuthCode: { __typename: 'VerifyAuthCodePayload', isVerified: boolean } };


export const VerifyAuthCodeDocument = gql`
    query VerifyAuthCode($input: VerifyAuthCodeInput!) {
  verifyAuthCode(input: $input) {
    isVerified
    __typename
  }
}
    `;

/**
 * __useVerifyAuthCodeQuery__
 *
 * To run a query within a React component, call `useVerifyAuthCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyAuthCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAuthCodeQuery(baseOptions: Apollo.QueryHookOptions<VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables> & ({ variables: VerifyAuthCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables>(VerifyAuthCodeDocument, options);
      }
export function useVerifyAuthCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables>(VerifyAuthCodeDocument, options);
        }
export function useVerifyAuthCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables>(VerifyAuthCodeDocument, options);
        }
export type VerifyAuthCodeQueryHookResult = ReturnType<typeof useVerifyAuthCodeQuery>;
export type VerifyAuthCodeLazyQueryHookResult = ReturnType<typeof useVerifyAuthCodeLazyQuery>;
export type VerifyAuthCodeSuspenseQueryHookResult = ReturnType<typeof useVerifyAuthCodeSuspenseQuery>;
export type VerifyAuthCodeQueryResult = Apollo.QueryResult<VerifyAuthCodeQuery, VerifyAuthCodeQueryVariables>;
export const namedOperations = {
  Query: {
    VerifyAuthCode: 'VerifyAuthCode'
  }
}